
<div
  v-if="isLotProgressif || isLotProgressif == null"
  class="couleur-fond align-items-center h-100 position-relative"
  :class="typeCarte"
  :style="{ '--couleur': isProgressifColor ? progressif.couleur : '#060606' }"
>
  <b-container
    class="banniere-progressif d-flex justify-content-center align-items-center h-100 m-auto"
    :class="grosseurCarte"
  >
    <b-row
      class="m-0 w-100 h-100 text-white"
      :class="{ 'justify-content-center': !mntProgressif }"
    >
      <b-col
        v-if="isProgressifImage"
        :cols="mntProgressif ? 4 : 12"
        class="graphik_bold d-flex align-items-center mh-100 pl-0 pr-1"
      >
        <div
          :class="{
            'h-100 w-100 d-flex justify-content-center align-items-center': !mntProgressif,
          }"
        >
          <b-img-lazy class="mh-100 mw-100" :src="jel_getFichierSrc(progressif.image)" alt="" />
        </div>
      </b-col>
      <b-col
        v-else
        :cols="mntProgressif ? 4 : 12"
        class="graphik_bold p-0 my-auto titre"
        :class="{ 'text-center': !mntProgressif }"
      >
        <div class="titre-progressif" :class="{ 'px-0': !mntProgressif }">
          <span :class="{ 'simple-ligne': !isProgressifTitre }">{{ titreLotProgressif }}</span>
        </div>
      </b-col>
      <b-col v-if="mntProgressif" cols="8" class="p-0 h-100">
        <div
          class="overflow-hidden graphik_semibold d-flex align-items-center justify-content-end montant w-100 h-100"
          :class="`montant-${$i18n.locale}`"
        >
          <div v-if="$i18n.locale == 'en'">$</div>
          <div
            v-for="(chiffre, index) in arrMntProgressif"
            :key="index"
            class="d-flex align-items-center h-100"
            :class="{ 'container-chiffre': !isNaN(chiffre) }"
          >
            <span
              :class="[
                isNaN(chiffre)
                  ? 'pt-2'
                  : 'case-chiffre chiffre d-flex align-items-center justify-content-center w-100',
              ]"
            >
              {{ chiffre }}
            </span>
          </div>
          <div v-if="$i18n.locale == 'fr'">$</div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</div>
